module.exports = __webpack_public_path__ + "static/media/nyheter.64567f47.jpg";